<template>
  <section id="team" class="team">
    <div class="team-decor">
      <div class="team-circle1"><img :src='"../../assets/images/team1-blue.png"' alt=""></div>
      <div class="team-circle2"><img :src='"../../assets/images/team3-blue.png"' alt=""></div>
      <div class="team-circle3"><img :src='"../../assets/images/team-blue.png"' alt=""></div>
    </div>
    <div class="container">
      <div class="row ">
        <div class="col-sm-12">
          <h2 class="title">{{ $t("company.team.nav") }} <span> {{ $t("company.team.nav1") }}</span></h2>
        </div>
        <div class="col-sm-12">
          <div>
            <carousel :className='"team-carousel"' :loop=true
                      :margin=30
                      :dots=true
                      :autoplay=true
                      :responsive="{0:{items:1,margin:5},600:{items:1,margin:5},768:{items:2},992:{items:3},1000:{items:3}}"
            >
              <div class="team-item" v-for="i in mappedTeam" :key="i.id">
                <div class="team-block">
                  <div class="team-box">
                    <div class="team-avtar">
                      <img :src='getImgUrl(i.avatarSrc)' alt=""
                           :style="i.id === 0 ? 'object-fit: scale-down;':  'object-fit: cover; '">
                    </div>
                    <div class="team-text">
                      <h3>{{ i.name }}</h3>
                      <h6>{{ i.position }}</h6>
                    </div>
                  </div>
                </div>
              </div>

            </carousel>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

export default {
  data: () => ({
    team: [
      {
        id: 1,
        avatarSrc: '1.jpg'
      },
      {
        id: 2,
        avatarSrc: '2.jpg'
      },
      {
        id: 3,
        avatarSrc: '3.jpg'
      },
      {
        id: 4,
        avatarSrc: '4.jpg'
      },
      {
        id: 5,
        avatarSrc: '5.jpg'
      },
      {
        id: 6,
        avatarSrc: '6.jpg'
      },
      {
        id: 7,
        avatarSrc: '7.jpg'
      },
      {
        id: 8,
        avatarSrc: '8.jpg'
      },
      {
        id: 9,
        avatarSrc: '9.jpg'
      },
      {
        id: 10,
        avatarSrc: '10.jpg'
      },
      {
        id: 11,
        avatarSrc: '11.png'
      },
      {
        id: 12,
        avatarSrc: '12.jpg'
      }
    ]
  }),
  methods: {
    getImgUrl(image) {
      return require('@/assets/images/team/' + image)
    }
  },
  computed: {
    mappedTeam: function () {
      return this.team.map(i => {
        return {id: i.id, avatarSrc: i.avatarSrc, name: this.$i18n.t(`company.team.text.${i.id}.name`), position: this.$i18n.t(`company.team.text.${i.id}.position`)}
      })
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/companyPage/company_team.vue